export default __webpack_public_path__ + "static/media/construction.65b00aac.png";